import React, { useEffect, useRef, useState } from 'react';
import { Group, Text, Transformer } from "react-konva/lib/ReactKonvaCore";
import { CANVAS_TOOL } from '../constants';

let remoteHandlerOutsider;
export default function TextCanvas({
    t, tempTextRef, drawId, uuid, line, selected, currentTool, canvasStyle, canvasX, canvasY, scale, isWhiteBoard, 
    setSelected, handlerDeleteLine, handlerSelectedLine, setLine
}) {
    const trRef = useRef();
    const shapeRef = useRef();
    const [ points, setPoints ] = useState(new Array());
    const [ canvasTool, setCanvasTool ] = useState(null);
    const [ ratio , setRatio ] = useState(1);
    const [ text, setText ] = useState(null);
    const [ option, setOption ] = useState({}); 

    useEffect(() => {
        if (line) {
            setCanvasTool(line.canvasTool);
            setPoints(line.points);
            if (line.text !== "" && line.text) setText(line.text);
        } else {
            setPoints(new Array());
            setCanvasTool(null);

            setText(null);
        }
    }, [line]);

    useEffect(() => {
        if (canvasTool) { 
            const ratio = canvasStyle.width / canvasTool.width || 1;
            setRatio(ratio);

            const lineThickness = Number(canvasTool.thickness );
            const option = {
                fill: canvasTool.color,
                width: canvasTool.figureWidth,
                height: canvasTool.figureHeight,
                opacity: canvasTool.opacity,
                x: points[0], y: points[1],
                fontSize: lineThickness,
                text: text || t("canvas.inputDblClick")
            };

            setOption(option);
        }        
    }, [canvasStyle, canvasTool]);

    useEffect(() => {
        if (selected) {
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        } 
    }, [selected]);

    useEffect(() => {
        if (!selected) {
            handlerOutSetText();
        }
    }, [selected]);

    const focusOnText = () => {
        if (currentTool.tool === CANVAS_TOOL.choice && !selected) handlerSelectedLine(uuid);
    }

    const handlerOutSetText = () => {
        const shapeElement = shapeRef.current;
        const textElement = tempTextRef.current;

        shapeElement.show();
        if (textElement) {
            textElement.style.display = 'none';

            while ( textElement.hasChildNodes() ) { 
                textElement.removeChild( textElement.firstChild ); 
            }
        }
    }

    const handlerSetText = () => {   
        if (currentTool.tool === CANVAS_TOOL.choice && selected) {
            const shapeElement = shapeRef.current;
            const textElement = tempTextRef.current;
            
            shapeElement.hide();
            textElement.style.display = 'block';

            const x = (textElement.getAttribute('data-style-width') - canvasStyle.width) / 2;
            const y = (textElement.getAttribute('data-style-height') - canvasStyle.height) / 2;

            const textarea = document.createElement("textarea");
            textElement.appendChild(textarea);
            textarea.value = text;
            textarea.style.top = shapeElement.y() * ratio + (y > 0 ? y : 0) + 'px';
            textarea.style.left = shapeElement.x() * ratio + (x > 0 ? x : 0) + 'px';
            textarea.style.color = shapeElement.fill();

            textarea.style.height = shapeElement.height() * ratio + 'px';
            textarea.style.width = shapeElement.width()* ratio + 'px';
            textarea.style.fontSize = shapeElement.fontSize() * ratio + 'px';
            textarea.style.fontFamily = shapeElement.fontFamily();
            textarea.style.transformOrigin = 'left top';
            
            textarea.addEventListener("keyup", sendTextPointer);

            let transform = '';
            let px = 0;
            let isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isFirefox) {
                px += 2 + Math.round(shapeElement.fontSize() / 20);
            }
            transform += 'translateY(-' + px + 'px)';
            textarea.style.transform = transform;
            textarea.focus();
        } 
        
    }

    const sendTextPointer = e => {
        e.preventDefault();
        const text = e.target.value;
                
        if (text !== '') {
            const newLine = { 
                ...line, 
                text 
            };
            setLine(newLine);
            
            APP.mateManagement.sendPointer(drawId, newLine, isWhiteBoard, focusUuid, focusIndex);
        }
    }

    function getPointerPosition() {
        const pos = shapeRef.current.position();
        
        const x = (pos.x  - canvasX) / scale;
        const y = (pos.y  - canvasY) / scale;
        return { x, y };
    }

    const handlerSetPoints = () => {
        const { x, y } = getPointerPosition();
        const newLine = { ...line, points: [x, y] };
        setLine(newLine);

        APP.mateManagement.sendPointer(drawId, newLine, isWhiteBoard, focusUuid, focusIndex);
    }

    const handlerTransform = () => {
        handlerOutSetText();
        const node = shapeRef.current;
        const { x, y } = getPointerPosition();
        
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();

        node.scaleX(1);
        node.scaleY(1);
        
        const figureWidth = Math.max(5, Math.min(node.width() * scaleX, canvasStyle.width - x));
        const figureHeight = Math.max(5, node.height() * scaleY);

        const newLine = { ...line, points: [x, y], canvasTool: { ...line.canvasTool, figureWidth, figureHeight } };
        setLine(newLine);

        APP.mateManagement.sendPointer(drawId, newLine, isWhiteBoard, focusUuid, focusIndex);
    }

    const onDeleteLine = () => {
        if (handlerDeleteLine) handlerDeleteLine(uuid);
    }

    return (
        <>
            <Group scaleX={ratio} scaleY={ratio}>            
                <Text ref={shapeRef}
                    {...option}
                    padding={5}
                    draggable={selected}

                    onClick={focusOnText}
                    onTap={focusOnText}
                    onDblClick={handlerSetText}
                    onDblTap = {handlerSetText}
                    onDragMove={handlerSetPoints}
                    onTransform={handlerTransform}

                    onMouseOver={onDeleteLine}
                    onTouchMove={onDeleteLine}
                /> 
                <Transformer ref={trRef} keepRatio={false} padding={5}
                    rotateEnabled={false}
                    enabledAnchors={['middle-left', 'middle-right', 'top-center', 'bottom-center']}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width < 30) return oldBox;
                            
                        return newBox;
                    }}
                /> 
            </Group>
        </>
    )
}